
import { CreateElement, RenderContext, FunctionalComponentOptions } from 'vue'
import * as T from '@/types'

import { UiButton } from '@hubsolv/hubsolv-ui'

const AppLogo: FunctionalComponentOptions = {
    functional: true,

    props: {
        light: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: true,
        },
        centered: {
            type: Boolean,
            default: true,
        },
    },

    render (h: CreateElement, context: RenderContext<any>) {
        return (
            <div 
                class={[
                    'app-logo', 
                    {
                        small: context.props.small,
                        large: !context.props.small,
                        centered: context.props.centered,
                    },
                ]}>
                <router-link to={{ name: T.CrmRoute.ACCOUNT_HOME}}>
                    <img class='logo' src={context.props.light? require('@/assets/creditordesk-logo-light.svg') : require('@/assets/creditordesk-logo-dark.svg')}>
                    </img>
                </router-link>
                <div class='tagline'> 
                    <span class='tagline-text' style={context.props.light? {color: 'white'} : {}}>powered by</span>
                    <a href='https://hubsolv.com' target='_blank'><img class='hubsolv-logo' src={context.props.light? require('@/assets/hubsolv-logo-light.svg') : require('@/assets/hubsolv-logo-dark.png')}></img></a>
                </div>
            </div>
        )
    },

}

export default AppLogo
